import { Flex, Tooltip, Typography } from 'antd';
import { ReactNode } from 'react';
import { Link, To } from 'react-router-dom';

import { useCheckPermission } from 'business/contextProviders/usePermissions';
import { Module_Enum } from 'generated/graphql';

import styles from './index.module.scss';

interface Props {
  route: To;
  title: string;
  icon: ReactNode;
  description: string;
  permissions: Module_Enum[];
  onClick: () => void;
  withDescription?: boolean;
}

const MenuEntry = ({
  route,
  title,
  icon,
  description,
  permissions,
  onClick,
  withDescription = true,
}: Props) => {
  const permissionCheck = useCheckPermission(permissions);
  if (!permissionCheck) {
    return null;
  }

  const menuLink = (
    <Flex gap={8} align="center">
      <span className={styles.icon}>{icon}</span>
      <Typography className={styles.title}>{title}</Typography>
    </Flex>
  );

  return withDescription ? (
    <Link to={route} className={styles.button} onClick={onClick}>
      <Tooltip title={description} placement="right">
        <span>{menuLink}</span>
      </Tooltip>
    </Link>
  ) : (
    <Link to={route} className={styles.button} onClick={onClick}>
      {menuLink}
    </Link>
  );
};

export default MenuEntry;
